import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormArray, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslationService, RoutingService, AuthStorageService, WindowRef, UrlPipe, I18nModule } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { pairwise, tap } from 'rxjs/operators';
import { MasterData } from 'src/app/core/model/master-data.model';
import { User } from 'src/app/core/model/users.models';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgFor } from '@angular/common';
import { NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';

@Component({
    selector: 'app-custom-addcontact',
    templateUrl: './custom-addcontact.component.html',
    styleUrls: ['./custom-addcontact.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, FormsModule, ReactiveFormsModule, NgFor, NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, RouterLink, UrlPipe, I18nModule]
})
export class CustomAddcontactComponent implements OnInit {
  // @Input() addupdate: boolean;
  @Input() updatecontact: User;
  @Input() admin: any;
  add: any;
  title: any;
  navigationData: any;
  customer: any;
  enableLoader = true;
  contacts: any;
  errorMessage: any;
  token: any;
  addcontactdetails: any;
  addcontactform: UntypedFormGroup;
  master: any;
  unit: any;
  newform: any;
  message = 'false';
  alphamumeric = '^[a-zA-Z0-9]+$';
  disabled = false;
  userid: any;
  usergroup: any;
  userGroupName: any;
  masterDataModel: MasterData;
  @Output() messageEvent = new EventEmitter<string>();
  loggedinUser: any;
  addupdate: any;
  role: any;
  error: any;
  isDisabled = false;
  userIdExist = false;
  errorMessageForEmail = '';
  commodityTypes = [];
  userRoles = [];
  addcontact: any;
  selectedCommodity: any = [];
  selectedRole:any =[];
  constructor(
    public toastService: ToastService,
    private cd: ChangeDetectorRef,
    private userAccountFacade: UserAccountFacade,
    private translation: TranslationService,
    private router: Router,
    private customProfileService: CustomProfileService,
    private winRef: WindowRef,
    private customProductService: CustomProductsService, private fb: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    // this.role = '';

    this.customProductService.getHomeLinkActive(false);
    this.addupdate = this.customProductService.addData;
    this.addcontact = this.customProductService.contactData;
    this.customProfileService.getcontacts(this.usergroup).pipe(tap(_ => console.log(_))).subscribe((data: any) => {
      this.contacts = data.users;
      const ind = this.contacts.findIndex(res => res.uid == localStorage.getItem("contactId"))
      this.addcontact = data.users[ind]
      //  this.commodityTypes =  this.addcontact.commodityType.map(res => res.id)
      this.commodityTypes = this.addcontact.commodityType
      this.userRoles = this.addcontact.userRole

      //   let newContact = data.contactList.push(this.newform)

      //   ('data.json', newData, err => {
      //     // error checking
      //     if(err) throw err;

      // }); 
    })
    if (this.addupdate) {
      this.customProductService.scrollToTop();
      this.userAccountFacade.get().subscribe((data: any) => {
        if (data) {
          if (this.winRef.localStorage.getItem('groupCompanyAdminFlag')) {
            this.admin = this.winRef.localStorage.getItem('groupCompanyAdminFlag');
          }
          this.userid = data.uid;
          this.usergroup = this.customProfileService.getGroupCompany();
          this.getMasterData();
          this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
            if (previous !== current) {
              if (current != null) {
                this.enableLoader = true;
                this.router.navigate(['/companies/myCompany/contacts/detail']);
              }
            }
          });
        }
      });

      // const orgData = this.authStorageService.getItem('user_data');
      this.addcontactform = this.fb.group({
        titleCode: [{ value: !this.addupdate ? this.updatecontact.titleCode : '', disabled: !this.admin }],
        firstName: [{ value: !this.addupdate ? this.updatecontact.name.split(' ')[0] : '', disabled: !this.admin },
        [Validators.required]],
        lastName: [{ value: !this.addupdate ? this.updatecontact.name.split(' ')[1] : '', disabled: !this.admin },
        [Validators.required]],
        email: [{ value: !this.addupdate ? this.updatecontact.uid : '', disabled: !this.admin }, [Validators.required, Validators.pattern('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,12}$')]],
        mobileNumber: [{ value: !this.addupdate ? this.updatecontact.mobileNumber : '', disabled: !this.admin },
        Validators.pattern('^[+0-9]+$')],
        alternateNumber: [{ value: !this.addupdate ? this.updatecontact.alternateNumber : '', disabled: !this.admin },],
        department: [{ value: !this.addupdate ? this.updatecontact.department : '', disabled: !this.admin },],
        jobTitle: [{ value: !this.addupdate ? this.updatecontact.jobTitle : '', disabled: !this.admin },],
        modeOfContact: [{ value: !this.addupdate ? this.updatecontact.modeOfContact : '', disabled: !this.admin }],
        role: [{ value: !this.addupdate ? this.role : '', disabled: !this.admin }],
        userRole: [{ value: this.selectedRole, disabled: !this.admin }],
        uid: [{ value: !this.addupdate ? this.usergroup : this.usergroup, disabled: !this.admin }],
        name: [{ value: !this.addupdate ? this.updatecontact.orgUnit.name : this.userGroupName, disabled: !this.admin }],
        linkedInProfile: [{ value: !this.addupdate ? this.updatecontact.linkedInProfile : '', disabled: !this.admin }],
        accessIndicator: [{ value: !this.addupdate ? this.updatecontact.accessIndicator : false, disabled: !this.admin }],
        commodityType: [{ value: this.selectedCommodity, disabled: !this.admin }]
      });
      this.translation.translate('breadcrumb.addContact.pageTitle').subscribe(res => {
        this.title = res;
      });
      this.translation.translate('breadcrumb.addContact.breadcrumb').subscribe(res => {
        this.navigationData = res;
      });
      this.translation.translate('home.toastErrorMessages.dataSaved').subscribe(res => {
        this.error = res;
      });
    } else {
      this.navigateToLandingPage();
    }
  }
  selectCommodity(item: any, selected: boolean) {
    if (!selected) {
      this.selectedCommodity.push(item)
    }
  }
selectUserRole(item:any, selected:boolean){
  if (!selected) {
    this.selectedRole.push(item)
  }
}
  createcontact(i): any {

    this.isDisabled = true;
    this.cd.detectChanges();
    this.newform = this.addcontactform.value;
    this.newform.unit = { uid: this.usergroup };
    delete this.newform.uid;
    const role = this.addcontactform.value.role;
    delete this.newform.role;
    this.newform.role = role;
    this.userIdExist = false;
    this.newform.commodityType = this.selectedCommodity;
    this.newform.userRole = this.selectedRole;
    this.customProfileService.createUpdateUser(this.usergroup, this.newform).subscribe(res => {
      this.userIdExist = false;
      if (res.error) {
        this.errorMessageForEmail = res.error;
        this.userIdExist = true;
        this.isDisabled = false;
      } else {
        this.toastService.show(this.error);
        this.enableLoader = false;
        this.navigateToLandingPage();
        this.cd.detectChanges();
      }
    }, (error) => {
      this.errorMessage = error;
      this.enableLoader = false;
    });
  }
  sendMessage(): any {
    this.messageEvent.emit(this.message);
  }
  navigateToLandingPage(): any {
    this.router.navigate(['/companies/myCompany/contacts/detail']);
  }

  getMasterData(): void {
    this.customProfileService.getMasterData(this.usergroup).subscribe((res: MasterData) => {
      if (res) {
        this.enableLoader = false;
        this.master = res;
        //this.userRole=this.master.userRole;
        this.masterDataModel = res;
        this.cd.detectChanges();
      }
    }, (error) => {
      this.errorMessage = error;
      this.enableLoader = false;
    });
  }
  // tslint:disable-next-line:typedef
  // selectedUserRole(value: any) {
  //   const array = this.master.userRole.find((x) => x.code === value)
  //   if (array) {
  //     this.SelecteduserRole.push(array);
  //     console.log(this.SelecteduserRole, 'userRole')
  //   }
  // }
  hideError() {
    this.userIdExist = false;
  }

}
